const closeNavigation = () => {
	const $trigger = $('.header__navigation-close, .header__navigation-overlay');

	$trigger.on('click', function(event) {
		$('.header__navigation').removeClass('is-open');

		event.preventDefault();
	});
}

closeNavigation();
